import { useMemo, useReducer } from "react"

import { KaiContext } from "@/organisms/KaiChat/hook/useKai"
import * as actions from "@/organisms/KaiChat/hook/useKai.actions"
import {
  getInitialState,
  reducer
} from "@/organisms/KaiChat/hook/useKai.reducer"

import type { PayloadDrawerState } from "@/organisms/KaiChat/hook/useKai.types"

export const KaiProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, getInitialState())
  const value = useMemo(
    () => ({
      toggle: () => dispatch(actions.toggle()),
      closeDrawer: (payload: Pick<PayloadDrawerState, "drawerId">) =>
        dispatch(actions.closeDrawer(payload)),
      updateDrawerState: (payload: PayloadDrawerState) =>
        dispatch(actions.updateDrawerState(payload)),
      setDirtyContext: (isDirty: boolean) =>
        dispatch(actions.setDirtyContext(isDirty)),
      ...state
    }),
    [state]
  )

  return <KaiContext.Provider value={value}>{children}</KaiContext.Provider>
}
